import { createIsomorphicFn } from "@tanstack/react-start";
import { getRequestHeaders } from "@tanstack/react-start/server";

export const getHeaders = createIsomorphicFn()
	.server(() => {
		return getRequestHeaders();
	})
	.client(() => new Headers());
